import { IconMenuOutline } from '@icons/IconMenuOutline'
import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { RestSchemas } from '@/contexts/QueryProvider'
import { isSuperUser } from '@/util'
import { useNavigate } from 'react-router'
import { useSessionStorage } from '@/hooks'
import { OrganisationDetailsForm } from '../../Forms/OrganisationDetailsForm'
import { CreateWorkspaceForm } from '../../Forms/CreateWorkspaceForm'
import { OrgUserForm } from '../../Forms/OrgUserForm'

type MessagesSubscriptionsOrganisationSummary = RestSchemas['Messages.Subscriptions.OrganisationSummary']

export function RowActionsMenu({ org }: { org: MessagesSubscriptionsOrganisationSummary }) {
  const navigate = useNavigate()

  const [userRole] = useSessionStorage('roles', 1)
  const canEditOrg = isSuperUser(userRole)
  return (
    <>
      <DropdownMenu
        onOpenChange={(open) => {
          // This is necessary to maintain the open state when we want to keep it open
          if (!open) {
            // Check if we need to prevent closing
            // This is a placeholder for custom logic you might need
            // We'll use other mechanisms to prevent closing on item click
          }
        }}
      >
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="size-8">
            <IconMenuOutline size={16} />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          onCloseAutoFocus={(e) => {
            // Prevent focus returning to trigger which can close the menu
            e.preventDefault()
          }}
        >
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onSelect={() => {
              navigate(`/subscriptions/${org.id}`)
            }}
          >
            View organisation
          </DropdownMenuItem>
          <OrganisationDetailsForm
            selectedOrg={org}
            sheetTitle="Edit organisation"
            sheetDescription="Edit the details of the organisation."
            sheetTrigger={
              <DropdownMenuItem disabled={!canEditOrg} onSelect={(e) => e.preventDefault()}>
                Edit
              </DropdownMenuItem>
            }
          />
          <OrgUserForm
            organisationId={org.id}
            sheetTitle={`${org.name} - New User`}
            sheetTrigger={
              <DropdownMenuItem disabled={!canEditOrg} onSelect={(e) => e.preventDefault()}>
                Add user
              </DropdownMenuItem>
            }
          />
          <CreateWorkspaceForm
            organisationId={org.id}
            sheetTitle={`${org.name} - New Workspace`}
            sheetTrigger={
              <DropdownMenuItem disabled={!canEditOrg} onSelect={(e) => e.preventDefault()}>
                Add workspace
              </DropdownMenuItem>
            }
          />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
